import axios from "axios";

import url from "@/config/url";

export default {
  registerUser(data) {
    // return axios.post(url.users.register, data);

    return axios.get("/moks/token.json");
  },

  loginUser(data) {
    // return axios.post(url.users.login, data);

    return axios.get("/moks/token.json");
  },

  updateUser(data) {
    return axios.post(url.users.update, data);
  },

  logoutUser() {
    // return axios(url.users.logout);

    return new Promise((res, _) => res());
  },

  getUser() {
    // return axios(url.users.info);

    return axios.get("/moks/user.json");
  }
};
